export const isCourseBlockVisible = () => process.env.REACT_APP_SHOW_COURSES_BLOCK === 'true';
